import { Controller } from '@hotwired/stimulus'

// Копирование read-only ссылки на турнир в буфер обмена.
export default class TournamentShareController extends Controller {
  static values = { url: String, copied: String }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.urlValue)
    } catch {
      // Fallback для контекстов без Clipboard API (например, http без TLS).
      const area = document.createElement('textarea')
      area.value = this.urlValue
      area.setAttribute('readonly', '')
      area.style.position = 'absolute'
      area.style.left = '-9999px'
      document.body.appendChild(area)
      area.select()
      document.execCommand('copy')
      area.remove()
    }
    const original = this.element.textContent
    this.element.textContent = this.copiedValue
    setTimeout(() => {
      this.element.textContent = original
    }, 2000)
  }
}
